import Bank from "../assets/images/bank.png"

function Registration() {
    return (
        <div>
            <p>All persons attending the Conference must complete an online registration form. Please read the below information before you complete the online registration form.</p>
            <p>Should you require further assistance, contact <a href="mailto:contact@ietbhec.com">contact@ietbhec.com</a></p>
            <h2>Registration</h2>
            <p className="font-italic">Note: The registration fees are set to USD (United States Dollar) (as a base currency) and VND (Vietnamese Dong) as local currency for all participants.</p>
            <table className="table table-bordered">
                <tbody>
                    <tr>
                        <td>Type of attendee</td>
                        <td>Type of registration</td>
                        <td>Fee (USD)</td>
                        <td>Fee (AUD)</td>
                        <td>Fee (VND)</td>
                    </tr>
                    <tr>
                        <td><strong>International</strong></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Full Registration- Early Bird (Closes on <font color="red">15 December 2026</font>)</td>
                        <td>300</td>
                        <td>425</td>
                        <td>8,000,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Full Registration- Student (Early Bird)<sup>#</sup></td>
                        <td>200</td>
                        <td>300</td>
                        <td>5,300,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Full Registration- Standard</td>
                        <td>400</td>
                        <td>550</td>
                        <td>10,600,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Full Registration- Standard (Student)</td>
                        <td>250</td>
                        <td>350</td>
                        <td>6,500,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Single Day / Accompanying Person Registration</td>
                        <td>150</td>
                        <td>200</td>
                        <td>4,000,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Masterclass/Workshop</td>
                        <td>50</td>
                        <td>75</td>
                        <td>1,300,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Extra Conference Gala Banquet Ticket</td>
                        <td>100</td>
                        <td>150</td>
                        <td>2,600,000</td>
                    </tr>
                    <tr>
                        <td><strong>Local<sup>*</sup></strong></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Full Registration- (Early Bird/Standard)</td>
                        <td>130</td>
                        <td>180</td>
                        <td>3,500,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Full Registration- Student (Early Bird/Standard)</td>
                        <td>100</td>
                        <td>150</td>
                        <td>2,600,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Single Day / Accompanying Person Registration</td>
                        <td>100</td>
                        <td>150</td>
                        <td>2,600,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Masterclass/Workshop</td>
                        <td>50</td>
                        <td>75</td>
                        <td>1,300,000</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Extra Conference Gala Banquet Ticket</td>
                        <td>50</td>
                        <td>75</td>
                        <td>1,300,000</td>
                    </tr>
                </tbody>
            </table>
            {/* <p>*Early bird registration closes on Friday, 10 October 2025.</p> */}
            <p># For student registration valid proof is required as a full-time student for the attendance.</p>
            <p>* Local Participants are citizens/residents of Vietnam.</p>
            
            <p className='no-newline-after-p'>Account holder: Trường Đại Học Sư Phạm (University of Science and Education)</p>
            <p className='no-newline-after-p'>Account number: 2002311090024</p>
            <p className='no-newline-after-p'>Bank: Ngân hàng Nông nghiệp và Phát triển Nông thôn, Chi nhánh Quận Liên Chiểu - Đà Nẵng</p>
            <p className='no-newline-after-p'>Vietnam Bank for Agriculture and Rural Development (Agribank), Lien Chieu District branch, Da Nang city</p>
            <p>SWIFT code: VBAAVNVX517</p>
            <img src={Bank} alt='Bank Account'/>

            <br></br>
            <br></br>
            <p><strong>Group registration and discount:</strong></p>
            <p>The Conference organising committee is pleased to offer group registration options for universities/organisations sending multiple delegates.</p>
            <p>For groups registering 10 or more delegates will be offered 10% discount. To access this discount, organisations are asked to email <a href="mailto:arun.patil@curtin.edu.sg" target='_blank' rel="noreferrer noopener">arun.patil@curtin.edu.sg</a>, with a list of delegate names in advance. A unique discount code for each organisation will then be provided for use when completing registrations via the online group registration portal. </p>

            <p><strong>Full Registration Entitlements</strong></p>
            <p>All Full and student registration fees include:</p>
            <ul className="ml-5">
                <li>Attendance to all conference sessions (excluding Master class/workshop) </li>
                <li>Conference proceedings (Paper publication and Scopus indexing) </li>
                <li>Conference program booklet </li>
                <li>Conference kit including satchel/bag </li>
                <li>Morning and afternoon teas and lunches </li>
                <li>Attendance at the Welcome Reception</li>
                <li>One ticket to attend the Conference Gala Banquet (Saturday, 27 February).</li>
            </ul>
            <br></br>
            <p><strong>Single Day Registration Entitlements:</strong></p>
            <ul className="ml-5">
                <li>Attendance to all conference sessions on the nominated day (excluding Master class/workshop) </li>
                <li>Conference proceedings (Paper publication and Scopus indexing) </li>
                <li>Conference program booklet</li>
                <li>Conference kit including satchel/bag</li>
                <li>Morning and afternoon teas and lunches (on the nominated day) </li>
            </ul>
            <br></br>
            <p><strong>Accompanying Spouse/Partner Registration Entitlements:</strong></p>
            <ul className="ml-5">
                <li>Attendance at the Welcome Reception (on Thursday, <font color="red">25 Feb</font>)</li>
                <li>Morning and afternoon teas and lunches (at the conference venue, Day 2 and 3)</li>
                <li>One ticket to attend the Conference Gala Banquet (Saturday, 27 February).</li>
            </ul>
            <br></br>
            <p>
                Delegates may attend an onsite workshop for US$50 per person. The cost includes morning tea or afternoon tea and light lunch. 
            </p>
            <p>In case that two papers are authored and presented by the same participant, the registration fee for second paper is USD150 (equivalent to single day registration fee). Full fees must be paid for the third and subsequent papers. </p>
            <p className="font-weight-bold">Cancellations</p>
            <p>All requests for cancellations must be in writing. Cancellations on or before <font color="red">07 February</font>, will incur a fee of USD100. No refunds will be made for cancellations after this date. </p>
            <p><strong>The link for online registration will be provided here in due course. </strong></p>
        </div>
    )
}

export default Registration